import payment from './payment.json';
import settingsLanguage from './settingsLanguage.json';
import settingsPayment from './settingsPayment.json';
import switchUser from './switchUser.json';
import settingsConfiguration from './settingsConfiguration.json';
import payCheckForm from './payCheckForm.json';

export const enAU = {
  payment,
  settingsLanguage,
  settingsPayment,
  switchUser,
  settingsConfiguration,
  payCheckForm,
};
